import { render, staticRenderFns } from "./SeniorOrders.vue?vue&type=template&id=7c87af1c&scoped=true&"
import script from "./SeniorOrders.vue?vue&type=script&lang=js&"
export * from "./SeniorOrders.vue?vue&type=script&lang=js&"
import style0 from "./SeniorOrders.vue?vue&type=style&index=0&id=7c87af1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87af1c",
  null
  
)

export default component.exports